import { defineComponent as _defineComponent } from 'vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsText from '@/components/vision/VsText.vue'
import { computed, ref, watchEffect } from 'vue'

type ItemType = { id: any; name: string; header?: any; divider?: any }


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSubmissionFilterInverseSelectionPreview',
  props: {
    items: null,
    selected: { default: () => [] },
    valueResolver: null
  },
  setup(__props: any) {

const props = __props as { items?: ItemType[], selected: any[], valueResolver?: (id: any) => Promise<ItemType> }



const previewItems = ref<ItemType[]>([])

watchEffect(() => {
  if (props.items) {
    previewItems.value = props.items.filter(
      (item) =>
        props.selected.includes(item.id) &&
        !('header' in item || 'divider' in item)
    )
  } else if (props.valueResolver) {
    Promise.all(props.selected.map(props.valueResolver)).then((results) => {
      previewItems.value = results
    })
  }
})

const shouldDisplayPreviewText = computed(() => {
  return previewItems.value.length > 0
})

const previewItemsText = computed(() => {
  const namesOfItemsToDisplay = previewItems.value
    .slice(0, 3)
    .map((item) => item.name)

  if (previewItems.value.length > 3)
    namesOfItemsToDisplay.push(`+${previewItems.value.length - 3} more`)

  return namesOfItemsToDisplay.join(', ')
})

return { __sfc: true,props, previewItems, shouldDisplayPreviewText, previewItemsText, VsWrapper, VsText }
}

})